import { useMutation } from 'react-query';

import { FetchAutocompleteTagParams, fetchAutocompleteTagRequest, FetchSimilarTagsParams, fetchSimilarTagsRequest, TagResponse } from '../lib/category';
import { ErrorResponse } from '../lib/types';

export const useFetchAutocompleteTagMutation = ({ onSuccess }: { onSuccess?: (response: TagResponse[], params: FetchAutocompleteTagParams) => void }) => {
  return useMutation<TagResponse[], ErrorResponse, FetchAutocompleteTagParams>((params) => fetchAutocompleteTagRequest(params), {
    onSuccess: (data, params) => {
      if (onSuccess) {
        onSuccess(data, params);
      }
    }
  });
};

export const useFetchSimilarTagsMutation = ({ onSuccess }: { onSuccess?: (response: TagResponse[], params: FetchSimilarTagsParams) => void }) => {
  return useMutation<TagResponse[], ErrorResponse, FetchSimilarTagsParams>((params) => fetchSimilarTagsRequest(params), {
    onSuccess: (data, params) => {
      if (onSuccess) {
        onSuccess(data, params);
      }
    }
  });
};
